import { dateFormat, parseDate } from '@mirai/locale';

import { parseCustomData, parseUserData, sendData } from './helpers';
import { TYPE } from '../../../../Core.constants';
import { formatPrice } from '../helpers/legacy';

const formatDate = (value) => dateFormat(parseDate(value, 'DD/MM/YYYY'), { delimiter: '-', format: 'YYYY-MM-DD' });

const joinUnique = (values = []) => [...new Set(values.filter(Boolean))].join(', ') || undefined;

export const bookingResponse = async ({
  device: { mobile } = {},
  instances = [],
  response: { tracking = {} } = {},
  store: { hotel: { id: hotelId } = {}, id: instanceId, language, type } = {},
} = {}) => {
  // ! -- TODO: use of tracking should be a temporary approach ---------------------------------------------------------
  const {
    bookingValues: { checkin, checkout, nights = 0 } = {},
    guestData = {},
    hotelInfo: { currency: hotelCurrency = {}, hotelCity, hotelProvince, propertyName, propertyType } = {},
    idReservation,
    pendingPayment,
    reservedRooms,
    totalNumAdults,
    totalNumChildren,
    totalNumRooms,
    totalPriceWithTaxes,
    totalPriceWithoutTaxes,
  } = tracking;

  const rooms = (reservedRooms || []).filter(Boolean);
  const contents = [];
  const miraiBookings = [];
  let numInfants = 0;
  let numItems = 0;
  rooms.forEach(({ averagePriceWithoutTaxes = 0, numRoomsToReserve = 1, occupation, rateId }) => {
    const quantity = nights * numRoomsToReserve;

    contents.push({ id: hotelId, itemPrice: formatPrice(averagePriceWithoutTaxes, hotelCurrency), quantity });
    miraiBookings.push(rateId);
    numInfants += Number(occupation?.numBabies) || 0;
    numItems += quantity;
  });

  const checkinDate = checkin && checkout ? formatDate(checkin) : undefined;
  const checkoutDate = checkin && checkout ? formatDate(checkout) : undefined;

  const commonData = {
    userData: parseUserData(guestData),
    customData: parseCustomData({
      boardName: joinUnique(rooms.map(({ defaultBoardDescription }) => defaultBoardDescription)),
      chainId: type === TYPE.CHAIN && instanceId ? `${instanceId}` : undefined,
      city: hotelCity,
      contentCategory: propertyType,
      contentIds: [hotelId].filter(Boolean),
      contents,
      ...(checkinDate && checkoutDate
        ? { checkinDate, checkoutDate, travelStart: checkinDate, travelEnd: checkoutDate }
        : undefined),
      device: mobile ? 'mobile' : 'desktop_tablet',
      hotelCurrency,
      language,
      lengthOfStay: nights,
      miraiBooking: miraiBookings.length > 1 ? miraiBookings : miraiBookings[0],
      numItems,
      numAdults: totalNumAdults,
      numChildren: totalNumChildren,
      numInfants,
      numRooms: totalNumRooms,
      orderId: idReservation,
      propertyName,
      rateName: joinUnique(rooms.map(({ rateName }) => rateName)),
      region: hotelProvince,
      roomName: joinUnique(rooms.map(({ roomTypeName }) => roomTypeName)),
      totalWithTaxes: [undefined, null].includes(totalPriceWithTaxes)
        ? undefined
        : formatPrice(totalPriceWithTaxes, hotelCurrency),
      value: formatPrice(totalPriceWithoutTaxes, hotelCurrency),
    }),
  };

  const purchaseEvent = 'Purchase';
  const btpEvent = 'BTP';
  const events = [
    pendingPayment ? btpEvent : undefined,
    purchaseEvent,
    ...(type === TYPE.CHAIN
      ? [`${purchaseEvent}_${hotelId}`, pendingPayment ? `${btpEvent}_${hotelId}` : undefined].filter(Boolean)
      : []),
  ].filter(Boolean);

  const responses = await Promise.all(
    events.flatMap((eventName) =>
      instances.map(({ idTracking, pixelId }) =>
        sendData({ ...commonData, eventId: idReservation, eventName, idTracking, pixelId }),
      ),
    ),
  ).catch(() => {});

  return responses;
};
